import { Button } from '../ui/button';

type MainErrorFallbackProps = {
  error: unknown;
};

export const MainErrorFallback = ({ error }: MainErrorFallbackProps) => {
  console.error(error);
  return (
    <div
      className="flex h-screen w-screen flex-col items-center justify-center text-destructive"
      role="alert"
    >
      <h2 className="text-lg font-semibold">
        Ooops, mi è sembrato di vedere un bug :(
      </h2>
      <Button
        className="mt-4"
        onClick={() => window.location.assign(window.location.origin)}
      >
        Aggiorna
      </Button>
    </div>
  );
};
